<div class="h-[calc(100vh-80px)] flex items-center justify-center bg-white text-center px-5 w-full">
    <div class="max-w-md mx-auto flex flex-col items-center gap-6">
        
        <h1 class="text-6xl font-semibold text-black leading-tight font-syne">
            404
        </h1>

        <h2 class="text-2xl font-semibold text-gray-900 font-syne">
            Page Not Found
        </h2>

        <a routerLink="/"
            class="mt-4 inline-flex items-center justify-center px-8 py-3.5 text-base font-medium text-white transition-all duration-300 ease-in-out bg-black border border-black rounded-lg hover:bg-white hover:text-black">
            Go Back Home
        </a>

    </div>
</div>